import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([])),
  ],
};

// export function tokenInterceptor(
//   req: HttpRequest<unknown>,
//   next: HttpHandlerFn,
// ): Observable<HttpEvent<unknown>> {
//   const authReq = req.clone({
//     headers: req.headers.set('GLOBToken', environment.apiToken).append('Access-Control-Allow-Origin', '*'),
//   });
//   return next(authReq);
// }
